<template lang="pug">
.user-check-icon(v-if="customer")
  span(@click.stop="$router.push({ name: 'DataCustomerEdit', params: { id: customer.id } })")
    b-icon(v-if="customer.isBlacklist" icon="alert-decagram" type="is-danger")
    b-icon(v-else icon="human-greeting-proximity" type="is-info")
</template>

<script>
export default {
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      customer: null
    };
  },
  async mounted() {
    this.customer = await this.$store.dispatch("customers/findOne", { id: this.id });
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
</style>